<template>
<div class="right-panel-container-list">
  <div class="simple-tab-container  simple-tab-theme-badge">
    <ul class="simple-tab ">
      <li @click="selectItem('order')" class="tab-item" :class="{'selected': activeItem == 'order'}" >
        <font style="vertical-align: inherit;">
          <font  style="vertical-align: inherit;">订单</font></font>
      </li>
      <li @click="selectItem('product')" class="tab-item" :class="{'selected': activeItem == 'product'}" >
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;" >产品</font></font>
      </li>
      <li @click="selectItem('voucher')" class="tab-item" :class="{'selected': activeItem == 'voucher'}" >
        <font style="vertical-align: inherit;">
          <font style="vertical-align: inherit;" >代金券</font></font>
      </li>
    </ul>

  </div>
  <div ref="sideContainer" id="sideContainer" class="content">

    <div v-show="activeItem == 'order'" class="lzd-panel-order">
      <div class="order-info-panel">
        <div style="margin: 8px 16px;">
        
          <Input>
              <Select slot="prepend" style="width: 80px">
                  <Option value="">全部</Option>
              </Select>
              <Button slot="append" icon="ios-search"></Button>
          </Input>
        </div>
        <div class="simple-loader">
          <div class="simple-placeholder">
            <List size="small">
              <Scroll v-if="order && order.data && order.data.length > 0" :height="sideScroll" :on-reach-bottom="getMoreOrder">
                <ListItem v-for="(item, i) in order.data" :key="i">
                  <div class="lzd-order-item">
                    <div class="order-header">
                      <div class="header-item-info">
                          <div class="header-item-status">
                            {{item.order_status}}
                          </div>
                          <div class="header-item-createtime">
                            {{item.created_at}}
                          </div>
                      </div>
                      <div class="header-item-order">
                        <div class="header-item-orderid">{{item.ordersn}}</div>
                        <Icon @click="onCopy(item.ordersn)" size="15" color="#8ea4d1" type="md-copy" />
                      </div>
                    </div>
                    <Divider style="margin: 10px;" dashed />
                    <div class="clip-list order-detail">
                      <div class="content">
                        <div class="sub-order-item" v-for="(orderItem, index) in item.products" :key="index">
                          <div v-if="index <= 1 || item.moreshow" class="item__body">
                            <img class="item__pic" :src="orderItem.item_image">
                            <div class="item__info">
                              <p @click="winControl.openURL(orderItem.product_detail_url)" class="title text-overflow">
                                <font style="vertical-align: inherit;cursor: pointer;">
                                  <font style="vertical-align: inherit;">{{orderItem.item_name}}</font></font>
                              </p>
                              <p class="properties">
                                <font style="vertical-align: inherit;">
                                  <font style="vertical-align: inherit;">{{orderItem.item_sku}}</font></font>
                              </p>
                              <p class="price-info">
                                <span class="price">
                                  <font style="vertical-align: inherit;">
                                    <font style="vertical-align: inherit;">{{orderItem.paid_price}}</font></font>
                                </span>
                                <span class="count">
                                  <font style="vertical-align: inherit;">
                                    <font style="vertical-align: inherit;">× {{orderItem.item_quantity}}</font></font>
                                </span>
                              </p>
                              <p v-if="item.review" class="review-info">
                                <Rate disabled :value="item.review[0].overall_rating" />
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div @click="moreshow(i)" v-show="item.products.length >= 2" class="more-item">
                        <a class="clip-toggle">
                          {{ item.moreshow ? '收起' : '查看更多' }}
                        </a>
                      </div>
                    </div>
                    <Divider style="margin: 10px;" dashed />
                    <div class="order-section">
                      
                      <div class="section-item">
                        <div class="section-item-label">
                          物流
                        </div>
                        <div class="section-item-content">
                          <a @click="showTraceModal(item)">查看物流</a>
                        </div>
                      </div>
                      <div class="section-item">
                        <div class="section-item-label">
                          买家名
                        </div>
                        <div class="section-item-content">
                          <a>{{item.buyer_username}}</a>
                        </div>
                      </div>
                      <div v-if="item.aftersale" class="section-item">
                        <div class="section-item-label">
                          售后备注
                        </div>
                        <div class="section-item-content">
                          <a>{{item.aftersale.remark}}</a>
                        </div>
                      </div>
                      
                    </div>
                    <Divider style="margin: 10px;" dashed />
                    <div class="order-footer">
                      
                      <div class="order-actions">
                        
                        <button v-if="item.aftersale" @click="appendRemarkModalShow(item.aftersale.id);" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">追加备注</font></font>
                        </button>
                        <button v-if="!item.aftersale" @click="addSalesModalShow(item);" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">添加售后</font></font>
                        </button>
                        <button @click="buyer_info(item)" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">客户资料</font></font>
                        </button>
                        <button @click="orderSend(item)" type="button" class="im-components-btn im-components-btn-primary im-components-btn-medium">
                          <font style="vertical-align: inherit;">
                            <font style="vertical-align: inherit;">发送</font></font>
                        </button>
                      </div>
                    </div>
                  </div>
                </ListItem>
                <div v-if="(order.current_page >= order.last_page && order.total != 0)" class="scroll-nomore">没有更多了</div>
              </Scroll>
            </List>
            <Empty :load="order.load"></Empty>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品列表 -->
    <div v-show="activeItem == 'product'" class="lzd-panel-product">
      <div class="order-info-panel">
        <div style="margin: 8px 16px;">
        
          <Input v-model="product_input" style="width: 250px">
              <Select v-model="product_select" slot="prepend" style="width: 80px">
                  <Option value="">全部</Option>
                  <Option value="title">标题</Option>
                  <Option value="item_id">商品id</Option>
                  <Option value="seller_sku">卖家sku</Option>
              </Select>
              <Button @click="getProduct()" slot="append" icon="ios-search"></Button>
          </Input>
        </div>
        <div class="simple-loader">
          <div class="simple-placeholder productList">
              <Scroll v-if="product && product.data && product.data.length > 0" :height="sideScroll" :on-reach-bottom="getMoreProduct" :distance-to-edge="-20">
            <List size="small">
                <ListItem v-for="(item, index) in product.data" :key="index">
                  <div class="item__wrapper product">
                    <div class="item__info">
                      <div class="background-default item__pic" :style="{ 'backgroundImage':'url('+ item.images[0] +')'}" ></div>
                      <div class="item__desc">
                        <div class="item__row">
                          <div class="text-overflow" :title="item.product_title">{{item.product_title}}</div>
                         </div>
                        <div class="item__row">
                          <div class="item__sku text-overflow" title="C28-">{{item.seller_sku}}</div></div>
                          <div style="justify-content: flex-start;align-items: center;" class="item__row">
                            <span style="font-size: 14px;color: #1a71ff;font-weight: 500;">{{item.special_price}} {{item.currency}}</span>
                            <div class="separator"></div>    
                            stock {{item.stock}}
                          </div>
                      </div>
                    </div>
                    <div class="item__ops">
                      <button @click="winControl.openURL((item.url))" type="button" class="im-components-btn im-components-btn-secondary im-components-btn-medium">查看</button>
                      <button @click="productSend(item)" type="button" class="im-components-btn im-components-btn-primary im-components-btn-medium">发送</button>
                      <button @click="setWeight(item)" class="im-components-btn im-components-btn-secondary"><Icon type="md-arrow-round-up" />置顶</button>
                      
                    </div>
                  </div>
                </ListItem>
            </List>
            <div v-if="(product.current_page >= product.last_page && product.total != 0)" class="scroll-nomore">没有更多了</div>
              </Scroll>
            <Empty :load="product.load"></Empty>
          </div>
        </div>
      </div>
    </div>


    <div v-show="activeItem == 'voucher'" class="im-voucher-section">
      <div class="simple-tab-container  simple-tab-theme-underline">
        <ul class="simple-tab voucher-tab" >
          <li @click="selectTab('CODE_VOUCHER')" class="tab-item" :class="{'selected': voucherType == 'CODE_VOUCHER'}" >
            <font style="vertical-align: inherit;" >
              <font style="vertical-align: inherit;" >活动</font></font>
          </li>
          <li @click="selectTab('COLLECTIBLE_VOUCHER')" class="tab-item" :class="{'selected': voucherType == 'COLLECTIBLE_VOUCHER'}" >
            <font style="vertical-align: inherit;" >
              <font style="vertical-align: inherit;" >收藏品</font></font>
          </li>
        </ul>
        
      </div>
      <div class="lzd-fields-tab">
        <div class="lzd-fields-list-box">
          <div class="list-view">
            <div>
              <div class="empty-default">
                <Icon :size="30" type="ios-document-outline" />
                <p class="content">
                  <font style="vertical-align: inherit;">
                    <font style="vertical-align: inherit;">无信息</font></font>
                </p>
              </div>
              <div class="loading-bar">
                <i class="im-components-icon im-components-icon-loading im-components-icon-large invisible"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <Modal
      v-model="traceModal"
      title="物流状态"
      :footer-hide="true"
      width="800"
      >
    <OrderTrace :orderId="orderId"></OrderTrace>
  </Modal>

<Modal 
  v-model="addSalesModal"
  title="添加售后"
  :footer-hide="true"
  width="400"
  >
   <Form :model="salesForm" :label-width="80">
    <FormItem label="订单类型">
      <Select v-model="salesForm.type" style="width:200px">
            <Option :value="1">常规</Option>
            <Option :value="2">退款</Option>
            <Option :value="3">紧急</Option>
            <Option :value="4">补发</Option>
            <Option :value="5">私下退换</Option>
        </Select>
    </FormItem>
    <FormItem label="备注">
      
      <quill-editor 
            v-model="salesForm.remark"
            :options="editorOption"
            ref="myQuillEditor">
      </quill-editor>
    </FormItem>
    <FormItem>
        <Button @click="aftersaleAdd()" type="primary">确定</Button>
    </FormItem>
  </Form>
</Modal>

<Modal
    v-model="appendRemarkModal"
    title="备注"
    :footer-hide="true"
    @on-cancel="appendRemarkModal = false">

 <div>
   <div class="remark-trace">
     <ul class="date-line">
       <li v-for="(item, index) in remarkList" :key="index" class="date-item">{{item.create_time_text}}</li>
     </ul>
     <Timeline>
         <TimelineItem style="height: 100px;" v-for="(item, index) in remarkList" :key="index">
           <div>              
            <pre class="context-wrap" v-html="item.remark"></pre>
            <span style="font-size: 10px;" v-if="item.user">跟进人: {{item.user.username}}</span>
           </div>
         </TimelineItem>
     </Timeline>
   </div>
   <Divider />
   <div>
      <Form :model="remarkFormItem" :label-width="80">
        <FormItem label="订单类型">
          <Select @on-change="(val)=>setSaleType(val, remarkFormItem.aftersale_id)" v-model="remarkFormItem.saleType" style="width:200px">
                <Option :value="1">常规</Option>
                <Option :value="2">退款</Option>
                <Option :value="3">紧急</Option>
                <Option :value="4">补发</Option>
                <Option :value="5">私下退换</Option>
            </Select>
        </FormItem>
        <FormItem label="订单状态">
          <Select @on-change="(val)=>setSaleStatus(val, remarkFormItem.aftersale_id)" v-model="remarkFormItem.orderStatus" style="width:200px">
            <Option :value="0">待处理</Option>
            <Option :value="1">已完成</Option>
          </Select>
       </FormItem>
       <FormItem label="备注">
        <quill-editor 
                 v-model="remarkFormItem.remark"
                 :options="editorOption"
                 ref="myQuillEditor">
           </quill-editor>
       </FormItem>
       <FormItem>
           <Button @click="addRemark()" type="primary">添加</Button>
       </FormItem>
     </Form>
   </div>
 </div>
</Modal>

</div>

</template>
<script>
const { scrollBottom,formatDateTime } = require("../../../../utils/ChatUtils");
import conf from "../../conf";
import MsgUtils from '@/utils/MsgUtils';
import RequestUtils from "@/utils/RequestUtils";
import Empty from "../empty.vue";
import OrderTrace from "./orderTrace.vue";

import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'; 
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: {
    Empty,
    OrderTrace,
    quillEditor
  },
  data() {
    return {
      activeItem: 'order',
      voucherType: 'CODE_VOUCHER',
      default_img: require("../../../../static/img/default_avatar.png"),
      error_img: 'this.src="'+require("../../../../static/img/default_avatar.png")+'";',
      loadImg: (imgSrc) => {
        return 'this.onload=null;this.src='+'"'+imgSrc+'";';
      },
      sideScroll: 500,
      productList: [],
      productPage: {},
      product_select: '',
      product_input: '',
      orderList: [],
      orderLoad: 1,
      traceModal: false,
      orderId: '',

      addSalesModal: false,
      salesForm: {
        id: '',
        type: 1,
        remark: ''
      },
      // 富文本编辑器啊配置
      editorOption: {
        modules: {
          toolbar: [
            [{size: []}],
            ['image']
          ]
        }
      },
      appendRemarkModal: false,
      remarkList: [],
      remarkFormItem: {
        aftersale_id: '',
        remark: '',
        orderStatus: 0,
        saleType: 1
      },
    };
  },
  props: ["chat"],
  mounted: function() {
    this.sideScroll = document.querySelector('body').offsetHeight - 64 - 36 - 203 - 56 - 48;
  },
  computed: {
    currentSession: {
      get: function() {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        let session = this.$store.state.shopee.currentSessionData[shop_id];
        return session ? session : false;
      }
    },
    currentStore: {
      get: function () {
        console.log(this.$store.state.shopee.currentStore);
        return this.$store.state.shopee.currentStore;
      }
    },
    order: {
      get: function () {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return this.$store.state.shopee.orderData[shop_id] || {};
      }
    },
    product: {
      get: function () {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return this.$store.state.shopee.productData[shop_id] || {};
      }
    },
    voucher: {
      get: function () {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return this.$store.state.shopee.voucherData[shop_id] || {};
      }
    },
    chatBoxElem: {
      get: function () {
        let shop_id = this.$store.state.shopee.currentStore.shop_id;
        return document.getElementById('sellerchat_'+shop_id).querySelector('.ivu-scroll-content');
      }
    }
  },
  methods: {
    showTraceModal (item) {
      this.traceModal = true;
      this.orderId = item.ordersn;
    },
    moreshow(index) {
      this.$store.commit("shopee/orderMoreShow", index);
    },
    formatDate(timestamp) {
      return formatDateTime(new Date(timestamp));
    },
    onCopy(text) {
      this.$copyText(text).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    selectItem(select) {
      this.activeItem = select;
      if (select == 'order') {
        this.getOrder();
      } else if (select == 'product') {
        this.getProduct();
      } else if (select == 'voucher') {
        this.getVoucher();
      }
    },
    selectTab(select) {
      this.voucherType = select;
      this.voucher();
    },
    /**
     * 发送产品
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    productSend (item) {
      let self = this;
      let param = new FormData();
      param.set("store_id", self.currentStore.id);
      param.set("to_id", self.currentSession.to_id);
      param.set("message_type", 'item');
      param.set("item_id", item.item_id);
      param.set("shop_id", self.currentStore.shop_id);   
      MsgUtils.request(this, param).then(() => {
        scrollBottom(self, this.chatBoxElem);
      })
    },
    /**
     * 商品详情
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    productDetail (item) {
      let url = '';
      if (this.currentStore.country == 'th') {
        url = 'https://shopee.co.'+this.currentStore.country+'/product/'+this.currentStore.shop_id+'/'+item.item_id+'/';
      } else if (this.currentStore.country == 'ph') {
        url = 'https://shopee.'+this.currentStore.country+'/product/'+this.currentStore.shop_id+'/'+item.item_id+'/';
      }
      window.open(url);
    },
    /**
     * 产品列表
     * @param  {Number} page [description]
     * @return {[type]}      [description]
     */
    getProduct (page = 1) {
      let self = this;
      let param = new FormData();
      param.set("page", page);
      param.set("store_id", self.currentStore.id);
      if (this.product_input) {
        param.set(this.product_select, this.product_input);
      }
      if (page == 1) {
        this.$store.commit("shopee/setProductData", null);
      }
      RequestUtils.request(conf.getProducts(), param).then(json => {
        console.log(json);
        this.$store.commit("shopee/setProductData", json);
      })
    },
    /**
     * 获取更多产品
     * @return {[type]} [description]
     */
    getMoreProduct () {
      return new Promise(resolve => {
        if (this.product.current_page < this.product.last_page) {        
          this.getProduct(this.product.current_page+1);
        }
        resolve();
      });
    },
    
    /**
     * 获取订单
     * @param  {Number} page [description]
     * @return {[type]}      [description]
     */
    getOrder (page = 1) {
      let param = new FormData();
      param.set("page", page);
      param.set("store_id", this.currentStore.id);
      param.set("buyer_id", this.currentSession.to_id);

      if (typeof page != Number || page == 1) {
        this.$store.commit("shopee/setOrderData", null);
      }
      RequestUtils.request(conf.getOrders(), param).then(json => {
        this.$store.commit("shopee/setOrderData", json);
      })
    },
    /**
     * 获取更多订单
     * @return {[type]} [description]
     */
    getMoreOrder() {
      return new Promise(resolve => {
        if (this.order.current_page < this.order.last_page) {        
          this.getOrder(this.order.current_page+1);
        }
        resolve();
      });      
    },
    /**
     * 发送订单
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    orderSend (item) {
      let self = this;
      let param = new FormData();
      param.set("store_id", self.currentStore.id);
      param.set("to_id", self.currentSession.to_id);
      param.set("message_type", 'order');
      param.set("order_sn", item.ordersn);     
      MsgUtils.request(this, param).then(() => {
        scrollBottom(self, this.chatBoxElem);
      })
    },
    getVoucher () {
      let self = this;
      let param = new FormData();
      param.set("store_id", self.currentStore.id);
      param.set("session_id", self.currentSession.session_id);
      param.set("voucher_type", this.voucherType);
      param.set("connector", 'shopee');
      RequestUtils.request(conf.getVoucherList(), param).then(json => {
        console.log(json);
        
      })
    },
    buyer_info (order) {
      let skus = new Array();
      for (let i=0; i<order.products.length; i++) {
        skus.push(order.products[i].item_sku);
      }
      let copyValue = '';
      copyValue += order.recipient_info_app.recipient_addr+'\n';
      copyValue += order.ordersn+'\n';
      copyValue += order.recipient_info_app.recipient+'\n';
      copyValue += order.recipient_info_app.recipient_phone+'\n';
      copyValue += order.created_at+'\n';
      copyValue += this.$store.state.shopee.currentStore.name+'\n';
      copyValue += skus.join(',')+'\n';

      this.$copyText(copyValue).then(() => {
        this.$Message.success('已成功复制到剪切板');
      }).catch(() => {
        this.$Message.error('复制失败');
      })
    },
    
    /* 售后 */
    addRemark() {
      let param = new FormData();
      param.set("connector", 'shopee' );
      param.set("aftersale_id", this.remarkFormItem.aftersale_id );
      param.set("remark", this.remarkFormItem.remark );
      RequestUtils.request(conf.addRemark(), param)
      .then(() => {            
        this.remarkFormItem.remark = '';
        this.appendRemarkModalShow(this.remarkFormItem.aftersale_id);    
      })
    },
    appendRemarkModalShow(aftersale_id) {
      this.appendRemarkModal = true;
      let self = this;
      let param = new FormData();
      param.set("connector", 'shopee' );
      param.set("aftersale_id", aftersale_id );
      RequestUtils.request(conf.getRemarks(), param)
      .then((json) => {            
        self.remarkList = json;
        self.remarkFormItem.aftersale_id = aftersale_id;
        self.remarkFormItem.saleType = json.order_type
      })
    },
    addSalesModalShow(item) {
      this.addSalesModal = true;
      this.salesForm.id = item.ordersn
    },
    aftersaleAdd() {
      this.addSalesModal = false;
      let param = new FormData();
      param.set("store_id", this.$store.state.shopee.currentStore.id);
      param.set("connector", 'shopee');
      param.set("ordersn", this.salesForm.id);
      param.set("type", this.salesForm.type);
      param.set("remark", this.salesForm.remark);

      RequestUtils.request(conf.aftersaleAdd(), param).then(() => {
        this.$Message.success('添加成功!');
        this.salesForm.type = 1;
        this.salesForm.remark = '';
        this.getOrder();
      })
    },
    // 设置售后状态
    setSaleStatus(value, id) {
      let param = new FormData();
      param.set("id", id );
      param.set('status', value );
      param.set("connector", 'shopee' );
      RequestUtils.request(conf.changeSalesStatus(), param)
      .then(() => {            
      })
    },
    // 设置售后类型
    setSaleType(value, id) {
      let param = new FormData();
      param.set("id", id );
      param.set('type', value );
      param.set("connector", 'lazada' );
      RequestUtils.request(conf.changeSalesStatus(), param)
      .then(() => {            
      })
    },
  }
};
</script>
<style lang="scss">
@import "@/static/styles/theme";

.right-panel-container-list {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;


  .simple-tab{
    height: 40px;
    padding-bottom: 3px;
    width: auto;
    margin: 16px 16px 0;
    display: flex;
    cursor: pointer;
    list-style: none;
    overflow: hidden;
    position: relative;

    .tab-item {
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1 1;
      position: relative;
      text-align: center;
      height: 100%;
      font-weight: 700;
      border-radius: 18px;
    }
    .tab-item.selected {
      color: #07f;
      background-color: rgba(0,29,233,.06);
    }
  }
}

.im-components-btn {
  position: relative;
  display: inline-block;
  font-style: normal;
  font-family: inherit;
  background: transparent;
  cursor: pointer;
  transition: all .3s ease-out;
  box-shadow: none;
  text-align: center;
  border-radius: 4px;
  font-size: 13px;
  flex: 1 1;
}

.im-components-btn-secondary {
  background-color: #fff;
  border-color: rgba(64,112,244,.5);
  color: #4070f4;
}

.im-components-btn.im-components-btn-primary:enabled {
  background-color: #0898ff;
}

.im-components-btn-medium {
  margin: 0;
  height: 28px;
  padding: 0 16px;
  line-height: 26px;
  border-width: 1px;
}

.im-components-btn+.im-components-btn {
  margin-left: 16px;
}

.productList {
  .item__wrapper {
    padding: 0px 12px;
    width: 29rem;
    box-sizing: border-box;
    .item__info {
      display: flex;
      overflow: hidden;

      .item__pic {
        background-position: 50%;
        background-size: cover;
        flex-shrink: 0;
        width: 56px;
        height: 56px;
        margin-right: 8px;
        margin-left: 0;
        border-radius: 4px;
        background-repeat: no-repeat;
        position: relative;
      }
      .item__desc {
        flex: 1 1;
        margin-right: 10px;

        .item__row {
          display: flex;
          justify-content: space-between;
          font-size: 12px;
          margin-top: 4px;
          overflow: hidden;

          .text-overflow {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            .item__units {
              flex-shrink: 0;
              color: #858b9c;
              font-size: 12px;
              transform: scale(.9);
            }
          }

          .item__sku {
            color: #858b9c;
          }
        }

        .item__price {
          font-size: 12px;
          font-weight: 700;
          margin-top: 4px;
        }
      }
    }
    .item__ops {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: center;


    }
  }
}

.content {
  display: flex;

  .lzd-panel-order {
    display: flex;
    flex-direction: column;
    flex: 1 1;
  }
  .lzd-panel-product {
    display: flex;
    flex-direction: column;
    flex: 1 1;
  }
  .im-voucher-section {
    display: flex;
    flex-direction: column;
    flex: 1 1;

    .voucher-tab {
      height: 30px;
      margin: 6px 0;
      padding-bottom: 3px;
      width: auto;
      display: flex;
      cursor: pointer;
      list-style: none;
      overflow: hidden;

      .tab-item {
        background: none;
        font-weight: unset;
      }
      .tab-item:before {
        width: 60%;
        left: 20%;
        height: 2px;
        transform: scaleX(0);
        content: " ";
        position: absolute;
        top: 100%;
        background: #07f;
      }
      .tab-item.selected:before {
        transform: scaleX(1);
      }
    }

    .lzd-fields-tab {
      display: flex;
      overflow: hidden;
      flex: 1 1;

      .lzd-fields-list-box {
        flex: 1 1;
        font-family: HelveticaNeue;
        color: #000;
        font-size: 14px;
        width: 100%;
        position: relative;
        overflow: hidden;

        .list-view {
          position: absolute;
          width: 100%;
          height: 100%;
          overflow-y: auto;
        }

        .empty-default {
          width: 100%;
          background: #fff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #8e969c;
          padding-top: 20px;
        }
      }
    }
  }

    .order-info-panel {
      flex: 1 1;
      display: flex;
      flex-direction: column;
    }

    .simple-loader {
      flex: 1 1;

      .simple-placeholder {
        position: relative;
        height: 100%;

        .empty-tip {
          top: 10%;
          width: 66%;
          padding-top: 20px;
          text-align: center;
          position: absolute;
          left: 50%;
          transform: translate(-50%,-50%);

          .no-order-tip {
            color: #8e969c;
          }
        }
      }
    }
  
}
</style>
